import React from "react";

const EngineLoader = ({ engineCount }) => {
    return (
        <div className="main_geo_loader_container">

            <div className="engine_loader_selection_cont">
                {Array.from({ length: engineCount }, (_, index) => (
                    <div key={index} className="engine_option_loader"></div>
                ))}
            </div>
            <div className="simulations_increaser_loader_container">
                <div className="simulations_increaser_loader_btn"></div>
                <div className="simulations_increaser_loader_cont"></div>
                <div className="simulations_increaser_loader_btn"></div>
            </div>

            <div className="text_btn_loader_cont">
                <div className="text_loader_cont">
                    <div className="text_loader_bottom fade-in"></div>
                    <div className="text_loader_top fade-in"></div>
                </div>
                <div className="btn_loader_cont">
                    <div className="btn_loader fade-in"></div>
                    <div className="btn_loader fade-in"></div>
                </div>
            </div>
        </div>
    );
};

export default EngineLoader;